import __var_0__ from './main.js';
/**

*
* Copyright (c) 2020 The Stdlib Authors.
*
* Licensed under the Apache License, Version 2.0 (the "License");
* you may not use this file except in compliance with the License.
* You may obtain a copy of the License at
*
*    http://www.apache.org/licenses/LICENSE-2.0
*
* Unless required by applicable law or agreed to in writing, software
* distributed under the License is distributed on an "AS IS" BASIS,
* WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
* See the License for the specific language governing permissions and
* limitations under the License.
*/

'use strict';

/**
* Evaluate the signum function for a single-precision floating-point number.
*
* @module @stdlib/math/base/special/signumf
*
* @example
* var signumf = require( '@stdlib/math/base/special/signumf' );
*
* var sign = signumf( -5.0 );
* // returns -1.0
*
* sign = signumf( 5.0 );
* // returns 1.0
*
* sign = signumf( -0.0 );
* // returns -0.0
*
* sign = signumf( 0.0 );
* // returns 0.0
*
* sign = signumf( NaN );
* // returns NaN
*/

// MODULES //
var signumf = __var_0__;


// EXPORTS //
export default signumf;
